<script>
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import VueEditor from '@/components/vue2-editor/VueEditor'
import Button from '@/components/Button'
import ViewTitle from '@/components/ViewTitle'
import MessageCard from '@/components/MessageCard'
import Checkbox from '@/components/Checkbox'
import PhoneNotifPreview from '@/components/PhoneNotifPreview'
import StringUtils from '@/utils/stringUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import NotificationsServices from '@/services/notifications'

const STEPS =
{
    SEND_NOTIFICATION: 0,
    NOTIFICATION_SENT: 1
}

export default
{
    name: 'edit-notifications',

    render () 
    {
        return (
            <div id='edit-notifications-view'>
                <view-title>Écrire une nouvelle notification</view-title>

                <div class='send-notification-step' v-show={this.currentStep == STEPS.SEND_NOTIFICATION}>
                    <div class='edit-notif'>
                        <floating-label-text-input placeholder='Le titre de votre notification' ref='notifTitle' v-model={this.notifTitle} />
                        <vue-editor placeholder='Le contenu de votre notification' show-toolbar={false} no-html={true}
                            ref='notifContent' v-model={this.notifContent} />
                        <checkbox label='Cette notification est une alerte importante' v-model={this.isImportantAlert} />
                        <Button has-shadow={true} type={this.areFieldsValid ? 'primary' : 'disabled'} text='Envoyer cette notification' on-click={this.onSendButtonClicked} />
                    </div>
                    <phone-notif-preview title={this.notifTitle || 'Le titre de votre notifications'}
                        content={this.notifContent || 'Le contenu de votre notification appraîtra ici. Vous devez remplir les champs demandés'} />
                </div>

                <div v-show={this.currentStep == STEPS.NOTIFICATION_SENT}>
                    <message-card icon={require('@/assets/img/paper-plane.svg')} message='Votre notification a été envoyée avec succès'
                        on-action-click={() => this.$router.push('/home')}  />
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            notifTitle: '',
            notifContent: '',
            currentStep: 0,
            isImportantAlert: false
        }
    },

    computed:
    {
        areFieldsValid ()
        {
            let isValid = true

            if (StringUtils.isEmptyString(this.notifTitle))
            {
                isValid = false
            }
            if (StringUtils.isEmptyString(this.notifContent))
            {
                isValid = false
            }

            return isValid
        }
    },

    mounted ()
    {
    },

    methods:
    {
        async onSendButtonClicked (event, button)
        {
            if (!this.areFieldsValid) return

            button.showSpinner = true

            const notification =
            {
                title: this.notifTitle,
                content: this.notifContent,
                targetSegments: [],
                targetTags: { }
            }

            if (LocalStorageUtils.sendPushNotifsToTest) notification.targetSegments = 'Test'

            if (this.isImportantAlert) notification.targetTags.notifiedOnImportantAlert = true
            else notification.targetTags.notifiedOnCommunication = true

            console.log('Sending notification', notification)
            try
            {
                const res = await NotificationsServices.sendNotification(notification, EnvironmentUtils.cityId, this.$store.state.user.token)
                console.log('Notification sent, response:', res)
                this.currentStep += 1
            }
            catch (e)
            {
                console.log('Notification send failed', e)
            }

            button.showSpinner = false
        }
    },

    components:
    {
        FloatingLabelTextInput,
        VueEditor,
        Button,
        ViewTitle,
        MessageCard,
        Checkbox,
        PhoneNotifPreview
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#edit-notifications-view
{
    margin-top: 12vw;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 4vh);
    
    margin-left: 5vw;
    margin-right: 5vw;

    .OnDesktop({
        margin-top: 4vw;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    .send-notification-step
    {
        display: flex;
        flex-direction: column;
        margin-top: 4vw;

        .OnTablet({ flex-direction: row; });

        .edit-notif
        {
            .OnTablet({ width: 45vw; });
            .OnDesktop({ width: 30vw; });

            .vue-editor
            {
                margin-top: 4vw;

                .OnDesktop({ margin-top: 2vw; });
                
                .ql-editor
                {
                    min-height: 20vw;

                    .OnDesktop({ min-height: 10vw; });
                }
            }

            .checkbox
            {
                margin-top: 10px;
            }

            .button
            {
                width: 100%;
                margin-top: 8vw;

                .OnDesktop({ margin-top: 3vw; });
            }
        }

       .phone-notif-preview
       {
           margin-top: 10vw;

            .OnMobile({ height: 140vw; });
            .OnDesktop({ height: 39vw; });

            .OnTablet({ width: 40vw; });
            .OnDesktop({ width: 35vw; });
            .OnLarge({ width: 30vw; });

            .OnTablet({
                margin-top: 0;
                margin-left: 5vw;
            });
       }
    }

    .message-card
    {
        .OnLarge({ margin: 6% 22%; });
    }
}
</style>



// WEBPACK FOOTER //
// src/views/EditNotifications.vue